let lastTrackedUrl = null

function currentPagePath() {
  return `${window.location.pathname}${window.location.search}`
}

function trackPageView() {
  if (typeof window.gtag !== "function" && !Array.isArray(window.dataLayer)) return
  if (lastTrackedUrl === window.location.href) return
  lastTrackedUrl = window.location.href

  const pageView = {
    page_title: document.title,
    page_location: window.location.href,
    page_path: currentPagePath()
  }

  if (typeof window.gtag === "function") {
    window.gtag("event", "page_view", pageView)
  }

  if (Array.isArray(window.dataLayer)) {
    window.dataLayer.push({
      event: "turbo_page_view",
      ...pageView
    })
  }
}

document.addEventListener("turbo:load", trackPageView)

if (!window.Turbo) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", trackPageView, { once: true })
  } else {
    trackPageView()
  }
}
